@if (claimUrl === '') {
  <ds-localized-spinner
    class="block"
    [dataLoading]="loading$"
    [loadingMessage]="'Looking for claim details'"
  >
  </ds-localized-spinner>
}
@if ((loading$ | async) === false) {
  <div>
    <div class="main">
      @if (claimsEnterpriseApp) {
        <div>
          <ds-claims-wrapper [loading]="loadingIframe" [claimUrl]="claimUrl"></ds-claims-wrapper>
        </div>
      }
    </div>
  </div>
}
